import React from 'react'
import InlineTextEditor from '../../inline-editors/InlineTextEditor'
import { CellBaseProps, resolveOverrideContext, isFieldEditing, makeEditClickHandler, makeFieldSaveHandler, overrideEditableClass } from './types'

/**
 * Renders the PAX (Passenger Capacity) column cell.
 */
export function PAXCell(props: CellBaseProps) {
  const { cellBorderClass, effectiveAircraft, aircraftTransaction } = props
  const { isSoldWithTransaction, isEditable, transOverride, override } = resolveOverrideContext(props)

  const hasOverride = isSoldWithTransaction
    ? (transOverride?.pax != null)
    : (override?.pax != null)

  const currentValue = isSoldWithTransaction
    ? (transOverride?.pax ?? aircraftTransaction!?.pax ?? null)
    : (override?.pax ?? effectiveAircraft.pax ?? null)

  const isEditing = isFieldEditing(props, 'pax', isSoldWithTransaction)

  return (
    <td className={`px-2 py-2 text-sm text-gray-900 text-center ${cellBorderClass}`}>
      <div
        className={overrideEditableClass(hasOverride, isEditable)}
        onClick={makeEditClickHandler(props, 'pax', isEditable, isSoldWithTransaction)}
      >
        {isEditing ? (
          <InlineTextEditor
            value={currentValue}
            fieldName="pax"
            inputType="number"
            min={0}
            placeholder="0"
            onSave={makeFieldSaveHandler(props, 'pax', isSoldWithTransaction)}
            onCancel={props.handleCancelEdit}
          />
        ) : (
          effectiveAircraft.pax || '-'
        )}
      </div>
    </td>
  )
}

